"use client";
import { RegisterForm } from "@/components/auth/RegisterForm.js";


export function RegisterPage() {
    return (
        <RegisterForm />
    );
}
